<div name="login-callback-page" attr.data-env="{{env}} | {{build}}" [ngSwitch]="view">
  <div class="row justify-content-md-center">
    <div class="col-12 col-md-6 col-lg-4">
      <div *ngSwitchCase="'no-errors'" class="d-flex align-items-center">
      </div>

      <jr-card-notification *ngSwitchCase="'error-general'" (cta)="onCloseMessage()">
        <span title>Error</span>
        <div description>
          Looks like we can't log you in. Please try again later.
        </div>
        <div actions>
          <a [href]="linkJayride" 
            class="btn btn-primary btn-block">
            Go to Jayride
          </a>
          <a [href]="linkContactUs"
            class="btn btn-secondary btn-block">
            Contact Support
          </a>
        </div>
      </jr-card-notification>

      <div *ngSwitchCase="'error-code-exchange'" class="rounded-12 color-bg-white p-6 shadow-down">
        <h3>Error</h3>
        <p>
          There was a problem processing your login. Please try signing in again. If the issue persists, please contact our support.
        </p>
        <button (click)="relogin()" class="btn btn-primary btn-block">
          Sign in Again
        </button>
        <a [href]="linkContactUs" class="btn btn-secondary btn-block">
          Contact Support
        </a>
      </div>

      <div *ngSwitchCase="'cookie-disabled'" class="rounded-12 color-bg-white p-6 shadow-down">
        <h3>Error</h3>
        <p>
          Please enable cookies and site data to log in to your account. 
          Jayride uses cookies and stores site data to ensure secure and 
          reliable service (learn more <a target="_blank" [href]="linkCookiesPolicy">here</a>). 
        </p>
        <p>
          See <a target="_blank" href="https://support.google.com/accounts/answer/61416?hl=en&co=GENIE.Platform%3DDesktop">how to enable cookies</a> and <a target="_blank" href="https://support.google.com/chrome/answer/14114868?hl=en&co=GENIE.Platform%3DDesktop&oco=0">how to allow sites to save data on your device</a>. 
          If you're a travel agent and the issue persists, please contact your administrator.
        </p>
        <a [href]="linkJayride"
          class="btn btn-primary btn-block">
          Go to Jayride
        </a>
        <a [href]="linkContactUs" class="btn btn-secondary btn-block">
          Contact Support
        </a>
      </div>

      <jr-card-notification *ngSwitchCase="'email-not-verified'" (cta)="onCloseMessage()">
        <span title>Thanks so much for joining Jayride.com</span>
        <div description>
          <p>
            Please check your email, including the spam or junk folder and follow 
            the instructions to verify your email address and finish setting up 
            your account.
          </p>
        </div>
      </jr-card-notification>

      <jr-card-notification *ngSwitchCase="'email-exists'" (cta)="onCloseMessage()">
        <span title>Account exists</span>
        <div description>
          <strong class="d-block pb-2">
            The user with such email already exists.
          </strong>
          Try to sign up with another email address.
        </div>
      </jr-card-notification>

      <jr-card-notification *ngSwitchCase="'account-deleted'" (cta)="onCloseMessage()">
        <span title>Account Deleted</span>
        <div description>Your account and data has been successfully removed.
        </div>
        <div actions>
          <a [href]="linkJayride" class="btn btn-primary btn-block">
            Return to Home
          </a>
        </div>
      </jr-card-notification>
    </div>
  </div>
</div>
